import { cloneElement, isValidElement } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material';
import { DefaultOutlinedButton, RedOutlinedButton } from './Buttons';

export const DecisionDialog = ({
  openDialog,
  dialogTitle,
  dialogDescription,
  closeOperation,
  requestOperation,
  requestText,
  closeText,
  RequestButton,
  requestButtonElement,
}) => {
  const renderRequestButton = () => {
    if (isValidElement(requestButtonElement)) {
      return cloneElement(requestButtonElement, {
        onClick: requestOperation,
        autoFocus: true,
        children: requestText,
      });
    }

    if (RequestButton) {
      return (
        <RequestButton onClick={requestOperation} autoFocus>
          {requestText}
        </RequestButton>
      );
    }

    return (
      <RedOutlinedButton onClick={requestOperation} autoFocus>
        {requestText}
      </RedOutlinedButton>
    );
  };

  return (
    <Dialog
      open={openDialog}
      onClose={() => {}}
      aria-labelledby="decision-dialog-title"
      aria-describedby="decision-dialog-description"
    >
      <DialogTitle id="decision-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="decision-dialog-description">{dialogDescription}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <DefaultOutlinedButton onClick={closeOperation}>{closeText}</DefaultOutlinedButton>
        {renderRequestButton()}
      </DialogActions>
    </Dialog>
  );
};
